import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client'
import { descReg } from '../components/DemandeTable/DemandeTable.helpers'
// import { Descriptions } from 'antd'
import { onError } from '@apollo/client/link/error'
import { GraphQLError } from 'graphql'

const hasuraApi = createHttpLink({
  uri: process.env.REACT_APP_HASURA_ENDPOINT,
})

// const visionApi = createHttpLink({
//   uri: process.env.REACT_APP_VISION_ENDPOINT,
// })

// ########## MIDDLEWARE
const authMiddleware = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('jwt')
  if (token) {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
  return forward(operation)
})

// ########## AFTERWARE
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach((value: GraphQLError) => {
      if (value.extensions?.code === 'invalid-jwt') {
        localStorage.removeItem('jwt')
        window.location.replace(`/login?from=${window.location.href.replace(window.location.origin, '')}`)
      }
    })
  if (networkError) console.log(`[Network error]: ${networkError}`)
})

// ########## AFTERWARE
// const addDatesLink = new ApolloLink((operation, forward) => {
//   return forward(operation).map((response) => {
//     if (response.data?.demande && response.data?.demande.__typename === 'd4_demande') {
//       console.log('response.data?.demande: ', response.data.demande)
//       // response.data.demande.__typename = 'd4_fn_view_demande'
//     }
//     return response
//   })
// })

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      d4_fn_view_demande: {
        keyFields: ['id'],
        fields: {
          description: {
            read(description) {
              const res = descReg.exec(description ?? '')
              const rap = description.slice(0, 17) === 'Demande de rappel' ? '📞 ' : ''
              return rap + `${res?.[3] || description}`
            },
          },
          batimentlibelle: {
            read(batimentlibelle) {
              return batimentlibelle ?? 'Général'
            },
          },
        },
      },
    },
  }),
  link: ApolloLink.from([errorLink, authMiddleware, hasuraApi]),
})

export default client
